var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.btnFlag)?_c('div',{staticClass:"scrollTop-wrap"},[_c('div',{staticClass:"go-top",on:{"click":function($event){return _vm.backTop()}}},[_vm._v("TOP")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }